import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions, ViewStyle} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return {
    headerListStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 16,
      height: 48,
      backgroundColor: colors.titanWhite,
      borderTopWidth: 2,
      borderBottomWidth: 2,
      borderTopColor: colors.athensGrey,
      borderBottomColor: colors.athensGrey,
    },
    headerTextStyle: {
      fontSize: 16,
      lineHeight: 24,
      color: colors.primaryTextColor,
      ...typography.notoSansSemibold,
    },
    defaultCellStyle: {},
    flexStart: {
      width: 100,
    },
    width200: {
      width: 200,
    },
  };
};
